import React from "react"
import { withFormController } from "components/Molecules/FormController"
import { useCurrentDc } from "store/auth.redux"

const DisplayAddres = ({ source }) => {
  const [dc] = useCurrentDc()
  const usrAdr = source?.user?.address
  const dcAdr = dc?.address
  const shipMethod = source?.shippingMethod

  return (
    <>
      {shipMethod === "HMD" && usrAdr && (
        <div className="mt-2" data-testid="adrress-text">
          <p className="vt-muted mb-0">Address</p>
          <p className="mb-0 text-sm">
            {usrAdr?.village}, {usrAdr?.district}
          </p>
          {usrAdr?.address && <p className="text-xs">{usrAdr?.address}</p>}
        </div>
      )}
      {shipMethod === "SPK" && dcAdr && (
        <div className="mt-2">
          <p className="vt-muted mb-0">Address ({dc.name || "Na"})</p>
          <p className="mb-0 text-sm">
            {dcAdr?.village}, {dcAdr?.district}
          </p>
          {dcAdr?.address && <p className="text-xs">{dcAdr?.address}</p>}
        </div>
      )}
    </>
  )
}

export default withFormController(DisplayAddres)
